import { ActionLabels } from '@sbv-clients/util-misc';

import {
  Button,
  Dialog,
  DialogActionsContainer,
  DialogContent,
  DialogHeader,
  ConfirmDialogButtons,
  DialogMessage,
  smallDialogBodySx,
  smallDialogSx,
  useRedesignDialogs,
  useToggleModal,
} from '../../index';

export const useDeleteConfirmationModal = (
  handleDelete: () => void,
  title: string,
  content: string
) => {
  const redesign = useRedesignDialogs();
  const { open, openModal, closeModal } = useToggleModal();

  const handleDeleteWithClose = () => {
    handleDelete();
    closeModal();
  };

  const modal = () => {
    if (redesign) {
      return (
        <Dialog open={open} fullWidth sx={smallDialogSx}>
          <DialogHeader title={title} onClose={closeModal} />
          <DialogContent sx={smallDialogBodySx}>
            <DialogMessage tone="danger">{content}</DialogMessage>
          </DialogContent>
          <DialogActionsContainer>
            <ConfirmDialogButtons
              cancelLabel={ActionLabels.Cancel}
              confirmLabel="Delete"
              danger
              onCancel={closeModal}
              onConfirm={handleDeleteWithClose}
            />
          </DialogActionsContainer>
        </Dialog>
      );
    }
    return (
      <Dialog open={open} fullWidth>
        <DialogHeader title={title} onClose={closeModal} />
        <DialogContent sx={{ mt: 6 }}>{content}</DialogContent>
        <DialogActionsContainer>
          <Button variant="outlined" onClick={closeModal}>
            {ActionLabels.Cancel}
          </Button>
          <Button variant="contained" onClick={handleDeleteWithClose}>
            {ActionLabels.Confirm}
          </Button>
        </DialogActionsContainer>
      </Dialog>
    );
  };

  return {
    modal,
    openModal,
  };
};
